import { WellSelection } from "features/WorklistTools/shared/interfaces";
import { getPlateWellIdFromRowAndColIndex } from "features/WorklistTools/shared/WorklistHelpers";
import { SourcePlateInfoState } from "../../state";

export const srcPlateToWellSelections = (
  sourcePlateInfo: SourcePlateInfoState[]
): WellSelection[] => {
  const wellSelections: WellSelection[] = [];

  for (let i = 0; i < sourcePlateInfo.length; i++) {
    const singlePlateWellSelections = sourcePlateInfo[i].wellInfo.map((wi) => {
      return {
        plateIndex: i,
        plateWellId: getPlateWellIdFromRowAndColIndex(
          wi.rowPos - 1,
          wi.colPos - 1
        ),
        isSelectable: true,
      };
    });

    wellSelections.push(...singlePlateWellSelections);
  }

  return wellSelections;
};
